module.exports = __webpack_public_path__ + "static/img/background.a473842e.png";